// @flow
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { handleError } from "../redux/actions/Error";
import FetchException from "../exceptions/FetchException";

/**
 * A hook that returns a memoized function to handle application-wide errors.
 *
 * By default, this handler orchestrates:
 * - Redirects for unauthorized, blocked, or concurrent users.
 * - Handles forced password change triggers.
 * - Saves the error in the Redux store (server-side).
 * - Triggers global XHR error notifications.
 */
export const useErrorHandler = (): ((
  error: string | Error | FetchException,
) => void) => {
  const dispatch = useDispatch();

  return useCallback(
    /**
     * @param {string | Error | FetchException} error - The error object or message to process.
     */
    (error: string | Error | FetchException) => {
      const err = typeof error === "string" ? new Error(error) : error;
      dispatch(handleError(err));
    },
    [dispatch],
  );
};
